import React from 'react';
import Footer from '../components/Footer/Footer';
import Bookings from '../components/Bookings/Bookings';
import './pagestyles/Booking.css';

function Give() {
  return (
    <div>
      <h1 className='bookingHeader'>Support the Music Ministry</h1>
      <Bookings
        title='Partner with the Ministry'
        intro='If you feel called to support the music ministry, please share your details below so we can get in touch.'
        messageLabel='Your Support Details:'
        buttonText='Send Inquiry'
        messagePlaceholder='Share how you would like to give, your preferred giving method, or any questions about supporting the ministry...'
      />
      <Footer />
    </div>
  );
}

export default Give;
